import { useEffect, useState } from "react";
import React from "react";
import { useApiClient } from "../../service/API";
import '../../styling/ErrorReworkList.css';

export default function ErrorReworkList({data}) {

    const getSystemTimeZone = () => {
        const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        return timeZone;
      };

      const formatDate = (dateString) => {
        const date = new Date(dateString + 'Z');
        if (isNaN(date)) return '';

        const systemTimeZone = getSystemTimeZone();

        return date.toLocaleDateString('en-GB', {
            timeZone: systemTimeZone,  // Use the system's time zone
            day: '2-digit',
            month: 'short',  // Abbreviated month (e.g., Jan, Feb, Mar)
            year: 'numeric',
        }) + ' ' + date.toLocaleTimeString('en-GB', {
            timeZone: systemTimeZone,
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,  // 24-hour format
        });
    };

    return (
        <div className="ticket-errorRework-log">
            <h2 className="ticket-errorRework-log-title">Ticket Error/Rework Log</h2>
            {data && data.length > 0 ? (
            data.map((item) => (
                <div key={item.id} className={`ticket-errorRework-card ${item.status.includes("REWORK")?'rework':'error'}`}>
                <p><strong>{item.status}</strong></p>
                <div className="ticket-errorRework-row">
                    <strong>Created By:</strong> <span>{item.createdBy}</span>
                </div>
                <div className="ticket-errorRework-row">
                    <strong>Created Date:</strong> <span>{formatDate(item.createdDate)}</span>
                </div>
                <div className="ticket-errorRework-row">
                    <strong>Stage:</strong> <span>{item.stage}</span>
                </div>
                <div className="ticket-errorRework-row">
                    <strong>Reason:</strong> <span>{item.reason}</span>
                </div>
                </div>
            ))
            ) : (
            <div className="ticket-errorRework-no-data">No data available</div>
            )}
        </div>
    );      
}
